import React from "react";

export default class FilterFieldsContainer extends React.Component {

}
